export default {
    // Header Section
    "discover_your": "Discover Your",
    "daily_horoscope": "Daily Horoscope",
    "daily_cosmic_guidance": "Daily Cosmic Guidance",
    "daily_horoscope_description": "Get personalized daily horoscope predictions tailored to your zodiac sign. Receive insights on love, career, health, and finances with daily lucky numbers, colors, and cosmic guidance to navigate your day successfully.",

    // Service Information
    "enter_details_for_horoscope": "Enter Your Details for Daily Horoscope",
    "daily_horoscope_subscription": "Daily Horoscope Subscription",
    "service_price": "Service Price",
    "daily_horoscope_subscription_note": "Monthly subscription for personalized daily horoscope delivery",

    // Form Fields
    "full_name": "Full Name",
    "enter_full_name": "Enter your full name",
    "name_cosmic_influence": "Your name resonates with cosmic vibrations for personalized predictions",
    "email_address": "Email Address",
    "enter_email_address": "Enter your email address",
    "phone_number": "Phone Number",
    "enter_phone_number": "Enter your phone number",
    "gender": "Gender",
    "male": "Male",
    "female": "Female",
    "other": "Other",
    "date_of_birth": "Date of Birth",
    "birth_date_zodiac_sign": "Essential for determining your zodiac sign and personalized predictions",
    "preferred_language": "Preferred Language",
    "english": "English",
    "hindi": "Hindi",
    "telugu": "Telugu",
    "kannada": "Kannada",
    "language_note": "Your daily horoscope will be delivered in the selected language",

    // Core Horoscope Features
    "daily_predictions": "Daily Predictions",
    "love_relationship_insights": "Love & Relationship Insights",
    "career_money_guidance": "Career & Money Guidance",
    "health_wellness_tips": "Health & Wellness Tips",
    "lucky_numbers_colors": "Lucky Numbers & Colors",
    "monthly_horoscope_bonus": "Monthly Horoscope Bonus",

    "what_you_get": "What Your Daily Horoscope Includes",
    "personalized_daily_readings": "Personalized Daily Readings",
    "love_career_predictions": "Love & Career Predictions",
    "daily_lucky_elements": "Daily Lucky Elements",
    "monthly_bonus_insights": "Monthly Bonus Insights",

    // Actions & Buttons
    "subscribe_to_horoscope": "Subscribe to Daily Horoscope",
    "processing_payment": "Processing Payment",
    "processing_request": "Setting Up Subscription",

    // Payment & Success Messages
    "thank_you": "Thank You",
    "payment_successful": "Payment Successful!",
    "horoscope_subscription_processing": "Your daily horoscope subscription is now active. You'll receive personalized cosmic guidance every morning to start your day with confidence.",
    "order_id": "Order ID",
    "payment_id": "Payment ID",
    "amount_paid": "Amount Paid",

    // Delivery Information
    "delivery_information": "Delivery Information",
    "daily_delivery": "Daily Delivery",
    "daily_horoscope_delivery_note": "Your personalized horoscope arrives every morning",
    "whatsapp_notification": "WhatsApp Updates",
    "whatsapp_delivery_note": "Receive daily horoscope on WhatsApp",
    "email_delivery": "Email Delivery",
    "email_delivery_note": "Daily horoscope delivered to",

    // What You'll Receive
    "what_youll_receive": "Your Daily Horoscope Package",
    "daily_horoscope_reading": "Personalized Daily Horoscope Reading",
    "love_relationship_daily_insights": "Love & Relationship Daily Insights",
    "career_financial_guidance": "Career & Financial Daily Guidance",
    "health_wellness_daily_tips": "Health & Wellness Daily Tips",
    "monthly_special_predictions": "Monthly Special Predictions",

    // Visual Content
    "sample_daily_horoscope": "Sample Daily Horoscope",
    "leo_horoscope_today": "Leo Horoscope Today",
    "sample_horoscope_reading": "Today brings opportunities for personal growth and financial gains",
    "sample_horoscope_preview": "Preview of your personalized daily horoscope with cosmic insights",
    "zodiac_signs": "Zodiac Signs",

    // Zodiac Sign Names
    "aries": "Aries",
    "taurus": "Taurus",
    "gemini": "Gemini",
    "cancer": "Cancer",
    "leo": "Leo",
    "virgo": "Virgo",
    "libra": "Libra",
    "scorpio": "Scorpio",
    "sagittarius": "Sagittarius",
    "capricorn": "Capricorn",
    "aquarius": "Aquarius",
    "pisces": "Pisces",

    // Status & Processing
    "your_horoscope_status": "Your Horoscope Subscription Status",
    "processing_your_subscription": "Activating Your Subscription",
    "subscription_processing_message": "Your daily horoscope subscription is being activated. You'll start receiving personalized cosmic guidance from tomorrow morning.",
    "subscription_id": "Subscription ID",
    "status": "Status",
    "processing": "Activating",
    "active": "Active",
    "confirmation_email_sent": "Confirmation email sent",
    "daily_whatsapp_updates": "Daily WhatsApp updates enabled",
    "first_horoscope_tomorrow": "First horoscope delivered tomorrow morning",

    // Support & Contact
    "contact_support": "Contact Horoscope Support",
    "need_help": "Need guidance?",
    "contact_us_at": "Reach us at",

    // Error Messages
    "please_fill_all_required_fields": "Please complete all required details",
    "payment_failed": "Payment unsuccessful. Please try again.",
    "subscription_failed": "Subscription activation failed. Contact our support team.",

    // Daily Horoscope Categories
    "general_forecast": "General Forecast",
    "love_romance": "Love & Romance",
    "career_profession": "Career & Profession",
    "health_wellbeing": "Health & Wellbeing",
    "finance_money": "Finance & Money",
    "family_relationships": "Family & Relationships",
    "travel_adventure": "Travel & Adventure",
    "spiritual_growth": "Spiritual Growth",

    // Lucky Elements
    "lucky_number": "Lucky Number",
    "lucky_color": "Lucky Color",
    "lucky_time": "Lucky Time",
    "lucky_direction": "Lucky Direction",
    "lucky_gemstone": "Lucky Gemstone",
    "avoid_color": "Color to Avoid",
    "avoid_time": "Time to Avoid",

    // Daily Ratings
    "love_rating": "Love Rating",
    "career_rating": "Career Rating",
    "health_rating": "Health Rating",
    "finance_rating": "Finance Rating",
    "overall_rating": "Overall Day Rating",

    // Planetary Influences
    "planetary_influence": "Planetary Influence",
    "moon_phase": "Moon Phase",
    "ruling_planet": "Ruling Planet Today",
    "planetary_transit": "Key Planetary Transit",
    "retrograde_alert": "Retrograde Alert",

    // Relationship Insights
    "single_horoscope": "Single Love Forecast",
    "relationship_horoscope": "Relationship Forecast",
    "marriage_horoscope": "Marriage Forecast",
    "friendship_forecast": "Friendship Forecast",
    "family_harmony": "Family Harmony",

    // Career Guidance
    "job_prospects": "Job Prospects",
    "business_forecast": "Business Forecast",
    "investment_advice": "Investment Advice",
    "career_decisions": "Career Decisions",
    "workplace_relationships": "Workplace Relationships",

    // Health Tips
    "physical_health": "Physical Health",
    "mental_wellbeing": "Mental Wellbeing",
    "exercise_recommendation": "Exercise Recommendation",
    "diet_suggestion": "Diet Suggestion",
    "stress_management": "Stress Management",

    // Weekly & Monthly
    "weekly_overview": "Weekly Overview",
    "monthly_highlights": "Monthly Highlights",
    "seasonal_forecast": "Seasonal Forecast",
    "year_ahead": "Year Ahead Preview",

    // Compatibility
    "compatible_signs_today": "Compatible Signs Today",
    "challenging_signs": "Challenging Signs",
    "best_match_today": "Best Match Today",
    "avoid_conflicts_with": "Avoid Conflicts With",

    // Remedies & Tips
    "daily_remedy": "Daily Remedy",
    "positive_affirmation": "Positive Affirmation",
    "meditation_tip": "Meditation Tip",
    "crystal_recommendation": "Crystal Recommendation",
    "mantra_for_today": "Mantra for Today",

    // Special Occasions
    "birthday_special": "Birthday Special Forecast",
    "new_moon_influence": "New Moon Influence",
    "full_moon_impact": "Full Moon Impact",
    "eclipse_effects": "Eclipse Effects",
    "festival_predictions": "Festival Predictions",

    // Subscription Management
    "subscription_active": "Subscription Active",
    "next_billing": "Next Billing Date",
    "cancel_subscription": "Cancel Subscription",
    "modify_subscription": "Modify Subscription",
    "subscription_history": "Subscription History",

    // Personalization
    "customize_preferences": "Customize Preferences",
    "delivery_time": "Preferred Delivery Time",
    "content_focus": "Content Focus Areas",
    "notification_settings": "Notification Settings",

    // Premium Features
    "premium_insights": "Premium Insights",
    "detailed_analysis": "Detailed Analysis",
    "astrologer_notes": "Astrologer's Personal Notes",
    "priority_support": "Priority Customer Support"
};
